/**
 * Formats an address for display (0x1234...5678)
 */
export function formatAddress(address: string): string {
  if (!address || address.length < 10) return address;

  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
}
